import { app } from '../../../../../app';
import { appProtocolDisplayName } from '../../../../../../util/sp-util';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.idp-authenticators.manage.applications', {
        url: '/applications',
        views: {
            '@company.idp-authenticators.manage': 'companyIdpAuthenticatorsManageApplications'
        },
        resolve: {
            applications
        },

    });
}

/** @ngInject */
function applications(idpAuthenticator, companyId, IdpAuthenticatorsService) {
    if(idpAuthenticator != null) {
        return IdpAuthenticatorsService.getAssignedApplications(companyId, idpAuthenticator.id)
            .then(applications => applications.map(app => ({...app, protocol: appProtocolDisplayName(app)})));
    }
}




// WEBPACK FOOTER //
// ./src/portal/states/company/idp-authenticators/manage/applications/idp-authenticator-applications.state.js